<template lang="pug">
v-container(fluid class="tw-h-full tw-overflow-hidden tw-rounded tw-pt-0" style="background: #f5f5fa")
  div(class="tw-flex tw-shadow tw-flex-col tw-h-full tw-bg-white tw-mt-0 tw-rounded-md tw-overflow-hidden")
    v-row(align="center" justify="space-between" class=" tw-bg-gray-lighten-3 px-2  tw-shadow tw-py-2 tw-pb-0 p-0")
      v-col(cols="12" md="" class=" mt-1")
        template(v-if="loading")
          v-skeleton-loader(type="heading" class="pl-4")
        template(v-else)
          span(class="md:tw-pl-2 tw-text-2xl tw-font-semibold tw-text-indigo-lighten-1") {{ opportunity.name }}
      v-col(cols="auto")
        template(v-if="loading")
          div(class="tw-w-56 ")
            v-skeleton-loader(type="heading" width="450" class="pl-4")
        template(v-else)
          kubiqa-misc-assign-user(item_type="opportunities" :key="key" :item="opportunity")
      v-col(cols="auto" class="")
        div(class="tw-overflow-hidden")
          v-btn(depressed class="!tw-m-0" color="rgba(94,129,244,0.80)" @click="edit")
            span(class="tw-font-bold") {{ $t('Common.edit') }}
          v-menu(
            offset-y
            nudge-left="5"
            nudge-bottom="3"
            left
            dark
            class="tw-mx-0 tw-px-0 tw-mt-2"
          )
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                @click=""
                v-bind="attrs"
                width="5"
                min-width="5"
                dense
                color="blue-grey"
                plain
                tile
                text
                v-ripple="false"
                v-on="on"
                class=" tw-p-0 k-btn-context"
              )
                v-icon(size="26px" class=" tw-pl-0 tw-mb-0 tw-pr-1 tw-pb-1") mdi-dots-vertical
            v-list(dense)
              v-list-item(class="tw-px-0")
                v-btn(@click="deleteItem()" text block class="my-0")
                  v-row(no-gutters class="tw-cursor-pointer")
                    v-col(cols="auto" class="mr-1")
                      v-icon(small color="white") mdi-trash-can
                    v-col(cols="auto")
                      span(class=" tw-text-white tw-font-bold") {{ $t('Common.delete') }}
    v-row(align="center" justify="center" class="tw-py-1")
      v-col(cols="8" md="")
        v-row(class="")
          v-btn-toggle(v-model="toggle_exclusive" mandatory)
            v-col(cols="auto" class="tw-mx-0 tw-px-0 tw-pl-2 md:tw-pl-6 tw-pr-1")
              v-btn(
                depressed
                :to="{ name: 'opportunityDetail' }"
                color="rgba(94,129,244,0.10)"
                height="42"
                class="tw-rounded-md"
              )
                span(class="tw-font-medium  tw-text-kPurple")
                  v-icon mdi-information-outline
                  span(v-if="!$vuetify.breakpoint.mobile" class="tw-pl-1 tw-font-bold") {{ $t('Opportunities.Common.info') }}
            v-col(cols="auto" class="tw-mx-0 tw-px-0 tw-pr-1")
              v-btn(
                depressed
                :to="{ name: 'opportunityTasks' }"
                color="rgba(94,129,244,0.10)"
                height="42"
                class="tw-rounded-md"
              )
                span(class="tw-font-medium tw-pl-1 tw-text-kPurple")
                  v-icon mdi-order-bool-ascending-variant
                  span(v-if="!$vuetify.breakpoint.mobile" class="tw-pl-1 tw-font-bold") {{ $t('Opportunities.Common.tasks') }}
            v-col(cols="auto" class="tw-px-0 tw-pr-1")
              v-btn(
                depressed
                :to="{ name: 'opportunityPitches' }"
                color="rgba(94,129,244,0.10)"
                height="42"
                class="tw-rounded-md"
              )
                span(class="tw-font-medium tw-pl-1 tw-text-kPurple")
                  v-icon mdi-briefcase-variant-outline
                  span(v-if="!$vuetify.breakpoint.mobile" class="tw-pl-1 tw-font-bold") {{ $t('Opportunities.Common.listings') }}
            v-col(cols="auto" class="tw-px-0 tw-pr-1")
              v-btn(
                depressed
                :to="{ name: 'opportunityFiles' }"
                color="rgba(94,129,244,0.10)"
                height="42"
                class="tw-rounded-md"
              )
                span(class="tw-font-medium tw-pl-1 tw-text-kPurple")
                  v-icon mdi-folder-open
                  span(v-if="!$vuetify.breakpoint.mobile" class="tw-pl-1 tw-font-bold") {{ $t('Opportunities.Common.files') }}
    v-row(no-gutters class="tw-h-full")
      v-col(class="tw-h-full")
        v-fade-transition(mode="out-in")
          router-view
  v-dialog(v-model="editDialog" max-width="75%" class="tw-ml-32")
    div(class="tw-bg-white edit-opp-modal")
      kubiqa-opportunities-edit-main(:key="key" @close="editDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      toggle_exclusive: undefined,
      editDialog: false,
      key: 1,
    };
  },
  methods: {
    edit() {
      this.key++;
      this.editDialog = true;
    },
    editDialogToggle() {
      this.editDialog = false;
    },
    deleteItem() {
      this.opportunity.item_type = 'opportunities';
      this.$store.commit('SET_DELETE', this.opportunity);
    },
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    contacts() {
      return this.$store.getters['opportunities/contacts/list'];
    },
    opportunity() {
      return this.$store.getters['opportunities/current_opportunity'];
    },
    loading() {
      return this.$store.getters['opportunities/loading'];
    },
  },
  mounted() {
    this.$store.dispatch('opportunities/contacts/getContacts', this.id);
    this.$store.dispatch('opportunities/view', this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped>
.edit-opp-modal {
  height: 80vh !important;
  max-height: 600px;
}
.v-icon {
  @apply tw-text-kPurple !important;
}
.v-item--active {
  color: red;
  background-color: #2f53c9 !important;
  color: #ffffff !important;
}

.v-item--active span,
.v-item--active .v-icon {
  color: #ffffff !important;
}
</style>
